module.exports = __webpack_public_path__ + "img/pay-vip.fa5c00d4.png";